module.exports = __webpack_public_path__ + "img/new-post.f3db54e9.svg";